<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="addColli">
            <div class="position-relative pagination-control">
                <div class="container-fluid bg-light py-3">
                    <data-table
                        :url="url"
                        :filters="filters"
                        :columns="columns"
                        :per-page="perPage"
                        :translate="translate"
                        :classes="classes"
                        :order-by="orderBy"
                        :order-dir="orderDir"
                        :meta="columns.meta"
                    >
                        <div slot="filters" slot-scope="{ tableFilters, perPage, collis }">
                            <div class="h2">Create colli</div>
                            <div class="row my-3 d-flex justify-content-end align-items-center">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="d-block mb-0 font-weight-bold">Select client</label>
                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                            <v-select
                                                :options="clientList"
                                                v-model="filters.clientId"
                                                label="name"
                                            >
                                            </v-select>
                                        </div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="colli.clientId==='' && isSubmit? 'border-danger':''">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-10">

                                </div>
                            </div>
                            <br/>
                        </div>
                        <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                        <tr>
                            <th @click="sort(column.id)" v-if="column.label!==''" scope="col"
                                v-for="column in columns">
                                <span> {{ column.label }} </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody ref="collisTable" slot="body" slot-scope="{ data }">
                        <tr>
                            <td style="width:15%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                <v-select
                                                    ref="clientListFocus"
                                                    class="client-list"
                                                    :clearable="false"
                                                    :clearSearchOnSelect="false"
                                                    :options="clientList"
                                                    required
                                                    v-model="newColli.client"
                                                    @input="getBookingList()"
                                                    label="name"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td style="width:5%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="off"
                                                       v-model="newColli.reference">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td style="width:35%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="off"
                                                       v-model="newColli.name">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td style="width:5%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <date-picker
                                                    manual-input
                                                    v-model="newColli.received_at" valueType="format"
                                                    input-class="border-0 py-0 shadow-none form-input"
                                                    :lang="datePickerOptions.lang"
                                                    placeholder="yyyy-mm-dd" format="YYYY-MM-DD">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="width:5%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control text-center  border-0 py-0 shadow-none form-input"
                                                       v-model="newColli.volume"
                                                       placeholder=""
                                                       value=""
                                                       v-number
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="width:5%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control text-center  border-0 py-0 shadow-none form-input"
                                                       v-model="newColli.weight"
                                                       placeholder=""
                                                       value=""
                                                       v-number
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="width:10%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                <v-select
                                                    required
                                                    :clearable="false"
                                                    :clearSearchOnSelect="false"
                                                    :options="locationList"
                                                    v-model="newColli.location"
                                                    label="name"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="width:10%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="off"
                                                       v-model="newColli.colli">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="width:10%">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="text"
                                                       required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder=""
                                                       autocomplete="off"
                                                       v-model="newColli.amount">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="width:5%">
                                <button class="btn btn-success btn-sm save-colli">
                                    <div class="material-icons-outlined cursor-pointer mr-1">check_box</div>
                                </button>
                            </td>
                        </tr>
                        <tr
                            :key="colli.id"
                            v-for="(colli,key) in data">
                            <td
                                :key="column.name"
                                v-for="column in columns"
                            >
                                <data-table-cell
                                    :value="colli"
                                    :name="column.name"
                                    :meta="column.meta"
                                    :comp="column.component"
                                    :classes="column.classes">
                                </data-table-cell>

                                <slot v-if="column.label === 'Client'">
                                    {{ colli.client.name }}
                                </slot>

                                <slot v-if="column.label === 'Name'">
                                    {{ colli.name }}
                                </slot>

                                <slot v-if="column.label === 'Reference'">
                                    {{ colli.reference }}
                                </slot>

                                <slot v-if="column.label === 'Received'">
                                    {{ colli.received }}
                                </slot>

                                <slot v-if="column.label === 'Volume'">
                                    {{ colli.totalVolume }}
                                </slot>

                                <slot v-if="column.label === 'Weight'">
                                    {{ colli.totalWeight }}
                                </slot>
                                <slot v-if="column.label === 'Location'">
                                    <div v-for="(location,key) in colli.colliBatchLocations">
                                        <span>{{ location }}</span> <br>
                                    </div>
                                </slot>
                                <slot v-if="column.label === 'Colli'">
                                    <div class="form-group d-flex align-items-center div-focus">
                                        <div> {{ colli.totalColliAmountByColliBatch }}</div>
                                        <div @click="toggleModalBatch(colli.colli_batch)"
                                             class="material-icons-outlined cursor-pointer text-white- mr-2-"
                                             title="">arrow_right
                                        </div>
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Save'">

                                </slot>
                            </td>
                        </tr>
                        </tbody>
                    </data-table>
                    <div>
                        <label class="pr-2">Goods per page:</label>
                        <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                            <select class="form-control bg-white border-0 py-0 shadow-none"
                                    v-model="filters.length"
                                    style="width: 150px;">
                                <option
                                    :key="index"
                                    :value="records"
                                    v-for="(records, index) in perPage">
                                    {{ records }}
                                </option>
                            </select>
                        </div>
                        <br/> <br/>
                    </div>
                </div>
            </div>
        </form>
        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalBatch}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog colli-grouped" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalBatch(null)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="pt-3">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th class="border-right text-left">ID</th>
                                        <th class="border-right text-left">Client</th>
                                        <th class="border-right text-left">Booking</th>
                                        <th class="border-right text-left">Reference</th>
                                        <th class="border-right text-left">Delivery</th>
                                        <th class="border-right text-left">Volume</th>
                                        <th class="border-right text-left">Weight</th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-bordered">
                                    <tr v-for="colli in colliGrouppedByColliBatch">
                                        <td>{{ colli.id }}</td>
                                        <td>{{ colli.client.name }}</td>
                                        <td>
                                            <span v-if="colli.booking!=null && colli.booking.id!=1">
                                             #B-{{ colli.booking.id }}
                                           </span>
                                        </td>
                                        <td> {{ colli.reference }}</td>
                                        <td> {{ colli.created_at }}</td>
                                        <td> {{ colli.volume }}</td>
                                        <td> {{ colli.weight }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalBatch" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalPrompt}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            We have already created colli for this booking.
                            Do you want to print labels of previously added colli, or add extra colli to booking?
                        </h5>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalPrompt"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="previousBooking.length>0">

                            <b>Reference:</b> {{ previousBooking[0].reference }}<br/>
                            <b>Colli:</b> {{ previousBooking[0].totalColliAmount }}<br/>
                            <b>Weight:</b> {{ previousBooking[0].totalWeight }} <br/>
                            <b>Volume:</b> {{ previousBooking[0].totalVolume }}<br/><br/>

                            <button class="btn btn-success"
                                    @click="printLabel(newColli.reference);toggleModalPrompt()">
                                Print previous
                            </button>
                            <div class="btn btn-primary mark-delivered" @click="storeBarcode()">
                                Add extra
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalPrompt" class="modal-backdrop fade show"></div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";

export default {
    name: "CreateBarcode",
    components: {DatePicker, VueTimepicker},
    mixins: [datePickerOptionsMixin],
    props: {
        url: {type: String, required: true},
        warehouse: {type: String, required: true},
    },
    data() {
        return {
            clientList: [
                {id: '', name: ''},
            ],
            bookingList: [
                {
                    id: '',
                    value: '',
                    name: '',
                    volume: '',
                    weight: '',
                    colli: '',
                    client_id: '',
                    client_name: '',
                    reference: ''
                },
            ],
            locationList: [
                {id: '', name: ''},
            ],
            colli: {},
            newColli: {
                received_at: this.predefinedReceivedData(),
                client: [],
                booking: [],
                volume: 0,
                weight: 0,
                colli: 0,
                amount: 1,
                reference: '',
            },
            colliGrouppedByColliBatch: {},
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
                clientId: '',
                groupReferences: 0,
                groupByColliBatch: 1,
                excludeDelivered: 1,
            },
            columns: [
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Reference',
                    id: 'reference',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Name',
                    id: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Received',
                    id: 'created_at',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Location',
                    id: '',
                    orderable: false,
                    visible: true,
                },
                {
                    label: 'Colli',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Amount',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Save',
                    id: '',
                    orderable: false,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search'
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            show: false,
            activeModalIntervalPrompt: false,
            activeModalIntervalBatch: false,
            previousBooking: [],
            loading: false,
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        sort(id) {
            const dir = this.filters.dir === 'asc' ? 'desc' : 'asc';

            this.$set(this.filters, 'id', id);
            this.$set(this.filters, 'dir', dir);
        },
        getBookingList() {
            axios.get(`/booking-list-by-client/${this.newColli.client.id}/1`)
                .then(({data}) => {
                    this.bookingList = [];
                    this.fillBookingList(data, this.newColli.client.name);
                }).catch()
        },
        fetchData() {
            axios.get('/client-list')
                .then(({data}) => {
                    this.clients = data.data;
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clientList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                }).catch(error => this.clients = []);
            axios.get('/booking-list/1')
                .then(({data}) => {
                    this.fillBookingList(data, null)
                }).catch();
            axios.get('/location-list-select')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.locationList.push({
                            id: value.id,
                            name: `${value.name} (${value.warehouse.nickname})`,
                        });
                    });
                }).catch();
        },
        addColli() {
            this.storeBarcode();
        },
        storeBarcode() {
            this.newColli.warehouse = this.warehouse;
            axios.post(`/create-barcode`, this.newColli).then(async (response) => {
                if (response.data.colliIds.length === 1) {
                    this.printLabel(response.data.colliIds[0]);
                } else {
                    let reload;
                    let n = 0;
                    for (const id of response.data.colliIds) {
                        n++;
                        reload = response.data.colliIds.length === n;
                        await this.printColli(id, reload);
                    }
                }
            }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response)
            })
        },
        printLabel(reference, isReprint = 0) {
            localStorage.setItem('printColli', reference);
            localStorage.setItem('printColliReprint', isReprint);
            window.location.reload();
        },
        fillBookingList(data, clientName) {
            this.newColli.booking = '';
            Object.entries(data.data).forEach(entry => {
                const [key, value] = entry;

                if (clientName === null) {
                    this.bookingList.push({
                        id: value.id,
                        value: `B-${value.id},  ${value.client_data.name}, ${value.dropoff_address != null ? value.dropoff_address.name : ''}, ${value.reference.substring(0, 50)}`,
                        volume: `${value.volume}`,
                        weight: `${value.weight}`,
                        reference: `${value.reference}`,
                        colli: `${value.colli}`,
                        client_id: `${value.client_data.id}`,
                        client_name: `${value.client_data.name}`,
                        colli_batch: `${value.colli_batch}`,
                    });
                } else {
                    this.bookingList.push({
                        id: value.id,
                        value: `B-${value.id}, ${clientName}, ${value.dropoff_address != null ? value.dropoff_address.name : ''}, ${value.reference.substring(0, 50)}`,
                        volume: `${value.total_volume}`,
                        weight: `${value.total_weight}`,
                        reference: `${value.reference}`,
                        colli: `${value.total_colli}`,
                        client_id: `${value.client.id}`,
                        client_name: `${value.client.name}`,
                        colli_batch: `${value.colli_batch}`,
                    });
                }
            });
        },
        // connectBooking() {
        //     axios.post(`/colli-register`, this.checked_colli).then((response) => {
        //         window.location.reload();
        //     }).catch((error) => {
        //     })
        // },
        predefinedReceivedData() {
            const currentDate = new Date();
            return currentDate.getFullYear()
                + '-' + (currentDate.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + currentDate.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2});
        },
        printColli(id = null, reload = false) {
            return new Promise((resolve) => {
                this.loading = true;
                id = id ? id : localStorage.getItem('printColli');
                axios({
                    url: `/colli/print-labels?printByReference=1&isReprint=${localStorage.getItem('printColliReprint')}&warehouseId=${this.warehouse}`,
                    method: 'POST',
                    data: {'reference': id}
                }).then((response) => {
                    if (response.data.printnode === 'missing printer') {
                        alert('PDF generated, but not sent to print since printer id is missing');
                    }
                    if (response.data.file !== null) {
                        axios({
                            url: `/settings/download-file/print_labels_${response.data.file}`,
                            method: 'GET',
                            responseType: 'blob'
                        }).then((response) => {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', `print_label.pdf`);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            localStorage.removeItem('printColli');
                            localStorage.removeItem('printColliReprint');
                        }).catch((error) => {
                            console.log(error)
                        }).finally(() => {
                            if (reload) {
                                window.location.reload();
                            }
                        });
                    }
                }).catch((error) => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false;
                    resolve();
                });
            });
        },
        onChangeBooking(event) {
            if (this.newColli.booking.id > 0) {
                this.newColli.volume = 0;
                this.newColli.weight = 0;
                this.newColli.colli = 0;
                this.newColli.amount = 1;
                axios.get(`/colli-list?bookingId=${this.newColli.booking.id}&searchAllWarehouses=1`)
                    .then(({data}) => {
                        if (data.data.length > 0) {
                            Object.entries(data.data).forEach(entry => {
                                const [key, value] = entry;
                                this.newColli.weight += parseFloat(value.weight);
                                this.newColli.volume += parseFloat(value.volume);
                                this.newColli.colli = parseInt(key) + 1;
                            });
                        }
                    });
            }
        },
        toggleModalBatch(batch) {
            if (batch !== null) {
                axios.post(`/colli-list-by-colli-batch`, {data: batch})
                    .then(({data}) => {
                        this.colliGrouppedByColliBatch = data.data;
                    }).catch()
            }
            const body = document.querySelector("body");
            this.activeModalIntervalBatch = !this.activeModalIntervalBatch;
            this.activeModalIntervalBatch
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        toggleModalPrompt() {
            const body = document.querySelector("body");
            this.activeModalIntervalPrompt = !this.activeModalIntervalPrompt;
            this.activeModalIntervalPrompt
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.clientListFocus.$refs.search.focus();
        });
    },
    created() {
        this.fetchData();
        if (localStorage.getItem('printColli') !== null) {
            this.printColli();
        }
    },
    filters: {
        number: function (value) {
            return value.toLocaleString('da-DK');
        }
    },
}
</script>
<style>
.save-colli {
    margin-bottom: 15px;
}

.booking-select .vs__dropdown-menu {
    width: 600px !important;
}

.colli-grouped {
    min-width: 90%;
}

</style>
